/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

export interface ELandActionArgs {
  type: ELandActionArgs_ELandType;
  /**
   * How long to wait for the E-Land to commence (as measured by the corresponding fault firing)
   * before timing out; waits indefinitely if <= 0.
   */
  waitForElandTimeoutS: number;
}

export enum ELandActionArgs_ELandType {
  /** VIO - default to VIO ELand */
  VIO = 0,
  AIRHAWK_ONLY = 1,
  UNRECOGNIZED = -1,
}

export function eLandActionArgs_ELandTypeFromJSON(object: any): ELandActionArgs_ELandType {
  switch (object) {
    case 0:
    case "VIO":
      return ELandActionArgs_ELandType.VIO;
    case 1:
    case "AIRHAWK_ONLY":
      return ELandActionArgs_ELandType.AIRHAWK_ONLY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ELandActionArgs_ELandType.UNRECOGNIZED;
  }
}

export function eLandActionArgs_ELandTypeToJSON(object: ELandActionArgs_ELandType): string {
  switch (object) {
    case ELandActionArgs_ELandType.VIO:
      return "VIO";
    case ELandActionArgs_ELandType.AIRHAWK_ONLY:
      return "AIRHAWK_ONLY";
    case ELandActionArgs_ELandType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface ELandResultData {
}

export interface ELandActionStateData {
}

function createBaseELandActionArgs(): ELandActionArgs {
  return { type: 0, waitForElandTimeoutS: 0 };
}

export const ELandActionArgs = {
  encode(message: ELandActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.waitForElandTimeoutS !== 0) {
      writer.uint32(21).float(message.waitForElandTimeoutS);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ELandActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseELandActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.waitForElandTimeoutS = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ELandActionArgs {
    return {
      type: isSet(object.type) ? eLandActionArgs_ELandTypeFromJSON(object.type) : 0,
      waitForElandTimeoutS: isSet(object.waitForElandTimeoutS) ? globalThis.Number(object.waitForElandTimeoutS) : 0,
    };
  },

  toJSON(message: ELandActionArgs): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = eLandActionArgs_ELandTypeToJSON(message.type);
    }
    if (message.waitForElandTimeoutS !== 0) {
      obj.waitForElandTimeoutS = message.waitForElandTimeoutS;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ELandActionArgs>, I>>(base?: I): ELandActionArgs {
    return ELandActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ELandActionArgs>, I>>(object: I): ELandActionArgs {
    const message = createBaseELandActionArgs();
    message.type = object.type ?? 0;
    message.waitForElandTimeoutS = object.waitForElandTimeoutS ?? 0;
    return message;
  },
};

function createBaseELandResultData(): ELandResultData {
  return {};
}

export const ELandResultData = {
  encode(_: ELandResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ELandResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseELandResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ELandResultData {
    return {};
  },

  toJSON(_: ELandResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ELandResultData>, I>>(base?: I): ELandResultData {
    return ELandResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ELandResultData>, I>>(_: I): ELandResultData {
    const message = createBaseELandResultData();
    return message;
  },
};

function createBaseELandActionStateData(): ELandActionStateData {
  return {};
}

export const ELandActionStateData = {
  encode(_: ELandActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ELandActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseELandActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ELandActionStateData {
    return {};
  },

  toJSON(_: ELandActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ELandActionStateData>, I>>(base?: I): ELandActionStateData {
    return ELandActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ELandActionStateData>, I>>(_: I): ELandActionStateData {
    const message = createBaseELandActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
